import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import MTable from "../../../../components/mtable"
import Title from "../../../../components/Title"
import { api } from "../../../../env"

export default function ManageCompanySparks() {
    const { id: companyId } = useParams()
    const navigate = useNavigate()
    const [companySparkIds, setCompanySparkIds] = useState([])
    const [added, setAdded] = useState([])
    const [removed, setRemoved] = useState([])

    useEffect(() => {
        api.get(`/companies/${companyId}/sparks/ids`)
            .then(res => setCompanySparkIds(res.data))
    }, [companyId])

    const handleSelection = (selectedItems) => {
        const selectedIds = selectedItems.map(i => i.id)
        setAdded(selectedIds.filter(id => !companySparkIds.includes(id)))
        setRemoved(companySparkIds.filter(id => !selectedIds.includes(id)))
    }

    const save = () => {
        api.put(`/companies/${companyId}/sparks/access`, { added, removed })
            .then(() => navigate(-1))
    }

    const mapper = { columns: [
        { label: "Name", value: (item) => item.name },
        { label: "Display Name", value: (item) => item.displayName },
        { label: "Description", value: (item) => item.description }
    ]}

    return (
        <div className="page-xl-centered standard-padding showing">
            <div className="flex space-between center gap-xs v-spacer-m">
                <Title>Manage Spark Access</Title>
                <button className="solid" onClick={save}>Save</button>
            </div>
            <MTable
                path={'sparks'}
                mapper={mapper}
                selectable={{
                    onChange: handleSelection,
                    multiple: true,
                    preselected: companySparkIds.map(id => ({ id }))
                }}
            />
        </div>
    )
}
